import React, { Component } from 'react'
import { Link } from 'react-router'
import config from 'cfg'
import Promise from 'bluebird'
import styled from 'styled-components'
import CopyToClipboard from 'react-copy-to-clipboard'
import { List, ListItem, Divider, FlatButton, Snackbar } from 'material-ui'
import CircularProgress from 'material-ui/CircularProgress';

import ContentCopy from 'material-ui/svg-icons/content/content-copy'
import Forward from 'material-ui/svg-icons/content/forward'
const _ = require('lodash');

const TournamentsList = styled.div`
    list-style: none;
    padding: 0;
    margin: 0 auto;
    max-width: 1170px;
    
    > div {
        border: 1px solid rgb(224, 224, 224);
        border-bottom: none;
        box-sizing: border-box;
        padding: 0 !important;
        margin: 10px 0;
    }
    
    .id {
        min-width: 120px;
        text-align: center;
    }
    
    .list-item {
        > div > div {
          padding: 0 !important;
        }
        
        a {  
          span {
            flex: 0 1 50%;
            &.id {
                flex: 0 1 30%;
                text-align: right;
              }
          }
        }
     }   
`;
const Loader = styled.div`
  text-align: center;
  display: flex;
  height: calc(100% - 284px);
  > * {
    margin: auto;
  }
`;
const SportMenu = styled.span`
  margin: 20px 0;
  display: block;
  border: none;
  a {
    color: inherit;
  }
`;
const sportIdToName = {
    23: 'basketball',
    51: 'volleyball',
    33: 'badminton',
    20: 'handball',
    5: 'hockey',
    1: 'soccer'
};
const tournamentsToShow = {
    1: [46, 245, 282, 85, 239, 256, 242, 47, 48, 132, 133, 87, 138, 54, 146, 55, 141, 57, 53, 71, 67, 59, 42, 73, 77, 50, 9375, 76, 292],
    51: [8884, 8883],
    20: [352, 354, 358, 350, 348, 361, 363, 387, 353, 355, 359, 349, 362, 368, 364, 388],
    5: [311, 24, 21, 9436, 33],
    23: [391, 390, 392],
    33: [9079]
};

export default class IDSTournaments extends Component {
    state = {
        tournaments: [],
        sport: this.props.params.sport,
        dataLoading: true,
        open: false
    };

    componentDidMount() {
        this.loadData();
    }

    componentWillReceiveProps(nextProps) {
        //when props are change
        this.setState({
            sport: nextProps.params.sport,
            dataLoading: true
        }, () => {
            this.loadData();
        });
    }

    render() {
        if (this.state.dataLoading) return <Loader><CircularProgress /></Loader>

        return <div>{this.renderTournaments()}</div>;
    }

    loadData() {
        const { sport } = this.state;
        const sportId = _.findKey(sportIdToName, name => name === sport);

        Promise.props({
            tournaments: fetch(`${config.apis.ss2}/tournaments?sportId=${sportId}`).then(response => response.json())

        }).then(res => {
            this.setState({
                tournaments: res.tournaments,
                dataLoading: false
            });

        });
    }

    getTournaments() {
        const { tournaments, sport } = this.state;

        if (!tournaments || !tournaments.length) return null;

        let sportId = _.findKey(sportIdToName, name => name === sport);

        let tournamentsBySportType = tournamentsToShow[sportId];

        return tournamentsBySportType.map((id) => {
            return tournaments.filter((tournament) => {
                return tournament.id === id;
            })[0];
        });
    }

    renderTournaments() {
        const { tournaments, sport } = this.state;

        if (!tournaments || !tournaments.length || !this.getTournaments()[0]) return null;

        const btnsPositioning = {
            right: 0,
            marginRight: 16,
            position: 'absolute',
            transform: 'translateY(-50%)',
            top: '50%'
        };
        const styleLink = {
            display: 'flex',
            textDecoration: 'none',
            color: 'inherit',
            padding: 16,
            cursor: 'pointer',
            fontSize: '.875rem'
        };
        const snackbarStyle = {
            textAlign: 'center'
        };

        let tournamentsList = this.getTournaments().map((tournament) => {
            const tournamentUrl = `/ids-finder/${sport}/tournaments/${tournament.id}`;

            return (
                <div key={tournament.id}>
                    <ListItem className='list-item'>
                        <Link to={tournamentUrl} style={styleLink}>
                            <span>{tournament.name}</span>
                            <span className='id'>{tournament.id}</span>
                        </Link>
                        <CopyToClipboard text={tournament.id}>
                            <div>
                                <div style={btnsPositioning}>
                                    <FlatButton
                                        label="Copy"
                                        primary={true}
                                        icon={<ContentCopy />}
                                        onClick={this.handleTouchTap}
                                    />
                                    <Link to={tournamentUrl}>
                                        <FlatButton
                                            primary={true}
                                            icon={<Forward />}
                                        />
                                    </Link>
                                </div>
                                <Snackbar
                                    open={this.state.open}
                                    message='ID copied to clipboard'
                                    autoHideDuration={3000}
                                    onRequestClose={this.handleRequestClose}
                                    contentStyle={snackbarStyle}
                                />
                            </div>
                        </CopyToClipboard>
                    </ListItem>
                    <Divider/>
                </div>
            );
        });

        const sportKeys = Object.keys(sportIdToName);

        let sportsMenuItems = sportKeys.map(key => {
            let url = `/ids-finder/${sportIdToName[key]}/tournaments`;

            return (
                <Link to={url} key={key}>
                    <FlatButton label={sportIdToName[key]} primary={true}></FlatButton>
                </Link>
            );
        });

        return (
            <TournamentsList>
                <h2 style={{textTransform: 'capitalize'}}>{sport} Tournaments</h2>
                <List>
                    <Divider/>
                    {tournamentsList}
                </List>
                <SportMenu>
                    {sportsMenuItems}
                </SportMenu>
            </TournamentsList>
        );
    }

    handleTouchTap = () => {
        this.setState({
            open: true
        });
    };

    handleRequestClose = () => {
        this.setState({
            open: false
        });
    };
}


/** WEBPACK FOOTER **
 ** ../src/dash/front/components/ids-finder/IDSTournaments.js
 **/